// src/pages/ForgotPassword.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../utils/api';
import AuthCard, { alertStyle, fullWidthBtn, linkStyle } from '../components/AuthCard';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState('');
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await authAPI.forgotPassword(email.trim());
      setSent(res.data.message);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong. Please try again.');
    } finally { setLoading(false); }
  };

  return (
    <AuthCard
      subtitle="Reset your password"
      footer={<>Remembered it? <Link to="/login" style={linkStyle}>Back to sign in</Link></>}
    >
      {sent ? (
        <div style={alertStyle('success')}>
          {sent} Check your inbox (and spam folder). The link expires in 1 hour.
        </div>
      ) : (
        <form onSubmit={submit}>
          {error && <div style={alertStyle('error')}>{error}</div>}
          <p style={{ fontSize: 12, color: '#4a5568', marginBottom: 14 }}>
            Enter the email you sign in with and we'll send you a link to choose a new password.
          </p>
          <div className="form-group" style={{ marginBottom: 20 }}>
            <label className="form-label">Email address</label>
            <input className="form-input" type="email" autoComplete="email" placeholder="you@example.com" value={email} onChange={e => setEmail(e.target.value)} required autoFocus />
          </div>
          <button type="submit" className="btn btn-primary" style={fullWidthBtn} disabled={loading}>
            {loading ? 'Sending…' : 'Send reset link'}
          </button>
        </form>
      )}
    </AuthCard>
  );
}
